module.exports = __webpack_public_path__ + "static/media/7_ service director Edmond Chan (Immediate Past President)-min.fd8cbf93.jpg";